import React from 'react';
import Icon from '../../../components/AppIcon';

const FacilityMap = () => {
  const zones = [
    { id: 1, name: 'Cardio Zone', icon: 'Activity', color: 'bg-blue-500', position: 'top-4 left-4' },
    { id: 2, name: 'Strength Training', icon: 'Dumbbell', color: 'bg-purple-500', position: 'top-4 right-4' },
    { id: 3, name: 'Group Classes', icon: 'Users', color: 'bg-green-500', position: 'bottom-4 left-4' },
    { id: 4, name: 'Recovery Zone', icon: 'Heart', color: 'bg-red-500', position: 'bottom-4 right-4' },
    { id: 5, name: 'Nutrition Bar', icon: 'Coffee', color: 'bg-orange-500', position: 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2' }
  ];

  return (
    <div className="bg-card rounded-xl shadow-md p-6 md:p-8 mb-8">
      <h2 className="text-2xl font-bold text-foreground mb-6">Facility Map</h2>
      
      {/* Interactive Map */}
      <div className="relative bg-accent/30 rounded-lg p-8 min-h-[400px] border-2 border-dashed border-border">
        {zones?.map((zone) => (
          <div
            key={zone?.id}
            className={`absolute ${zone?.position} group cursor-pointer`}
          >
            <div className={`${zone?.color} w-16 h-16 rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-smooth`}>
              <Icon name={zone?.icon} size={28} className="text-white" />
            </div>
            <div className="absolute top-full mt-2 left-1/2 -translate-x-1/2 bg-foreground text-background px-3 py-1 rounded-lg text-xs font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-smooth">
              {zone?.name}
            </div>
          </div>
        ))}
        
        {/* Legend */}
        <div className="absolute bottom-4 left-4 bg-card rounded-lg p-4 shadow-md">
          <p className="text-xs font-semibold text-muted-foreground mb-2">LEGEND</p>
          <div className="space-y-2">
            {zones?.map((zone) => (
              <div key={zone?.id} className="flex items-center gap-2">
                <div className={`${zone?.color} w-3 h-3 rounded-full`} />
                <span className="text-xs text-foreground">{zone?.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <p className="text-sm text-muted-foreground mt-4 text-center">
        Hover over zones to see details • Real-time equipment availability coming soon
      </p>
    </div>
  );
};

export default FacilityMap;